import { z } from '../zod';
import { FormLayoutValidationSchema } from '../page/formLayout';

// Quantity prices the booking, so a guest is never asked it.
export const GUEST_QUESTION_ELEMENTS = [
  'text',
  'textarea',
  'number',
  'select',
  'multiple-choice',
  'multi-select',
  'checkbox',
  'date',
  'time',
  'date-time',
  'email',
  'phone',
  'country',
  'tax-id',
  'po-number',
  'address',
] as const;

export const GUEST_QUESTION_TYPES = [
  '',
  'company-name',
  'phone',
  'first-name',
  'last-name',
  'name',
  // The editor posts it back when Email address is edited; the API refuses adding a second one.
  'email',
  // The editor sets these on Tax ID and PO number questions.
  'tax-id',
  'po-number',
] as const;

// The editor posts the whole field form, so unknown keys pass through to the field model, which
// validates them; the keys that place a question are always set by the API.
export const GuestQuestionInputValidationSchema = z
  .object({
    label: z.string().trim().min(1, 'Label is required'),
    element: z.enum(GUEST_QUESTION_ELEMENTS).default('text'),
    type: z
      .enum(GUEST_QUESTION_TYPES)
      .nullish()
      .transform(type => type ?? ''),
  })
  .passthrough();

export type GuestQuestionInput = z.infer<typeof GuestQuestionInputValidationSchema>;

export const ReorderGuestQuestionsBodyValidationSchema = z.object({
  order: z.array(z.string().regex(/^[0-9a-fA-F]{24}$/, 'Invalid field id')).min(1),
});

export const SaveGuestQuestionsLayoutBodyValidationSchema = z.object({
  layout: FormLayoutValidationSchema,
});

export const GuestQuestionValidationSchema = z.record(z.string(), z.unknown());
export const GuestQuestionsResponseValidationSchema = z.array(GuestQuestionValidationSchema);

export const GuestQuestionsLayoutResponseValidationSchema = z.object({
  questions: GuestQuestionsResponseValidationSchema,
  guestFormLayout: FormLayoutValidationSchema,
});
